import React, { useEffect, useState } from 'react';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
    Container,
    Row,
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Table,
    Modal,
} from "reactstrap";
import classnames from "classnames";
import Tender from './Tender';
import { fetchNodeData } from 'utils/common-fetchData';
import secureLocalStorage from 'react-secure-storage';
import Loader from 'pages/Separate/Loader';


const TenderIndex = () => {

    const [verticalActiveTab, setverticalActiveTab] = useState("");
    const [fixedSideTab, setFixedSideTab] = useState(false);
    const [isLoading, setLoading] = useState(false)
    const [TenderDocModal, setTenderDocModal] = useState(false)
    const [documents, setDocuments] = useState([])
    useEffect(() => window.scrollTo(0, 0), [verticalActiveTab]);

    document.addEventListener('scroll', () => {
        if (window.scrollY > 68) {
            setFixedSideTab(true);
        }
        else {
            setFixedSideTab(false);
        }
    })

    document.title = "Tenders | Zithas Crm";

    const toggleVertical = (tab) => {
        if (verticalActiveTab !== tab) {
            setverticalActiveTab(tab);
        }
    };
    const token = secureLocalStorage.getItem('auth_token')
    const [source, setSource] = useState([])

    useEffect(() => {
        const fetchResource = async () => {
            const res = await fetchNodeData(setLoading, `tenderSource`, token);
            if (res?.status == 200) {
                setSource(res?.data)
                setverticalActiveTab(res?.data[0]?.id)
            }
        }
        fetchResource()
    }, [])

    const fetchData = async () => {
        const response = await fetchNodeData(
            setLoading,
            `tenderDocuments`,
            secureLocalStorage.getItem("auth_token")
        );
        if (response?.data) {
            setDocuments(response.data);
            setTenderDocModal(true)
        }
    };


    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <div className="page-content mb-4">
                <Container fluid >
                    <Breadcrumbs
                        title={"Dashboard"}
                        breadcrumbItem={"Tender"}
                    />
                    <div className="tender-doc">
                        <button
                            onClick={() => fetchData()}
                            className="border-radius btn btn-purple me-2"
                        >
                            <i className="dripicons-document me-2 icon-center"></i>
                            Tender Documents
                        </button>
                    </div>


                    <Row className='gx-4 justify-content-between di-flex align-items-top'>
                        <Col md="2" className='px-0'>
                            <Nav pills className={`side-tab flex-column px-2 py-3
                            ${fixedSideTab ? 'fixed-side-tab' : ''} h-100`}>
                                {source?.map((obj, i) => {
                                    return (
                                        <NavItem key={i}>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({
                                                    "mb-2": true,
                                                    active: verticalActiveTab == obj?.id,
                                                })}
                                                onClick={() => {
                                                    toggleVertical(obj?.id);
                                                }}
                                            >
                                                {obj?.name}
                                            </NavLink>
                                        </NavItem>
                                    )
                                })}
                            </Nav>
                        </Col>
                        <Col md="10">
                            <div className='card bg-transparent mb-0'>
                                <TabContent
                                    activeTab={verticalActiveTab}
                                    className="text-muted mt-4 mt-md-0" >
                                    {source?.map((obj, i) => {
                                        return (
                                            <TabPane tabId={obj?.id} key={i}>
                                                <Tender sourceId={obj?.id} verticalActiveTab={verticalActiveTab} />
                                            </TabPane>
                                        )
                                    })}
                                </TabContent>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>

            {/* View Tender Document Modal */}
            <Modal isOpen={TenderDocModal} size="lg" centered>
                <div className="modal-header">
                    <h5 className="modal-title mt-0">View Tender Document</h5>
                    <button
                        type="button"
                        onClick={() => {
                            setTenderDocModal(false)
                        }}
                        className="btn-modal-close"
                    >
                        <span className="btn-modal-span">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Table className="table-bordered">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Document</th>
                            </tr>
                        </thead>

                        <tbody>
                            {documents?.map((obj, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{obj?.documentName}</td>
                                        <td>
                                            {obj?.document ? (
                                                <a className="btn btn-sm activity-log-btn text-info" href={obj?.document} target="_blank" rel="noopener noreferrer">
                                                    <i className="fas fa-eye pe-2"></i>
                                                    View Document
                                                </a>
                                            ) : 'No Attachment'}

                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            </Modal>
            {/* ------------ */}
        </React.Fragment>
    )
}

export default TenderIndex;